import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import './navbar.css'

const Navbar = (props) => {
  return (
    <div
      data-role="Header"
      className={`navbar-thq-header-container-elm ${props.rootClassName} `}
    >
      <header className="navbar-thq-navbar-elm">
        <Link to="/" className="navbar-navlink1">
          <div className="navbar-thq-branding-elm1">
            <img
              alt={props.finbestAlt1}
              src={props.finbestSrc1}
              className="navbar-thq-romania-elm"
            />
          </div>
        </Link>
        <div className="navbar-thq-btn-elm">
          <span className="navbar-text10 formula_button">{props.text8}</span>
          <span className="navbar-text11">{props.text82}</span>
        </div>
        <div id="open-mobile-menu" className="navbar-thq-burger-menu-elm">
          <svg viewBox="0 0 1024 1024" className="navbar-thq-menu-elm">
            <path d="M64 192h896v192h-896zM64 448h896v192h-896zM64 704h896v192h-896z"></path>
          </svg>
        </div>
      </header>
      <div id="mobile-menu" className="navbar-thq-mobile-menu-elm">
        <div className="navbar-thq-top-elm">
          <Link to="/" className="navbar-navlink2">
            <div className="navbar-thq-branding-elm2">
              <img
                alt={props.imageAlt1}
                src={props.imageSrc1}
                className="navbar-image10"
              />
            </div>
          </Link>
          <div id="close-mobile-menu" className="navbar-thq-close-menu-elm">
            <svg viewBox="0 0 1024 1024" className="navbar-icon2">
              <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
            </svg>
          </div>
        </div>
        <div id="close-sub-menu" className="navbar-thq-mid-elm">
          <a href="#ambassador" className="navbar-link10">
            <div className="navbar-thq-ambassador-elm">
              <div className="navbar-thq-active-elm1">
                <div className="navbar-thq-content-elm1">
                  <img
                    alt="image"
                    src={props.imageActive2}
                    className="navbar-image11"
                  />
                  <div className="navbar-thq-text-elm1">
                    <div className="navbar-container10">
                      <span className="navbar-text12">
                        {props.chapterActive2}
                      </span>
                      <div className="navbar-thq-divider-elm1"></div>
                      <span className="navbar-text13">
                        {props.indexActive8}
                      </span>
                    </div>
                    <span className="navbar-text14">{props.nameActive1}</span>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <a href="#brand" className="navbar-link11">
            <div className="navbar-thq-brand-elm">
              <div className="navbar-thq-active-elm2">
                <div className="navbar-thq-content-elm2">
                  <img
                    alt="image"
                    src={props.imageActive11}
                    className="navbar-image12"
                  />
                  <div className="navbar-thq-text-elm2">
                    <div className="navbar-container11">
                      <span className="navbar-text15">
                        {props.chapterActive11}
                      </span>
                      <div className="navbar-thq-divider-elm2"></div>
                      <span className="navbar-text16">
                        {props.indexActive11}
                      </span>
                    </div>
                    <span className="navbar-text17">{props.nameActive11}</span>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <a href="#mhouse" className="navbar-link12">
            <div className="navbar-thq-m-house-elm">
              <div className="navbar-thq-active-elm3">
                <div className="navbar-thq-content-elm3">
                  <img
                    alt="image"
                    src={props.imageActive21}
                    className="navbar-image13"
                  />
                  <div className="navbar-thq-text-elm3">
                    <div className="navbar-container12">
                      <span className="navbar-text18">
                        {props.chapterActive21}
                      </span>
                      <div className="navbar-thq-divider-elm3"></div>
                      <span className="navbar-text19">
                        {props.indexActive21}
                      </span>
                    </div>
                    <span className="navbar-text20">{props.nameActive21}</span>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <a href="#mhub" className="navbar-link13">
            <div className="navbar-thq-m-hub-elm">
              <div className="navbar-thq-active-elm4">
                <div className="navbar-thq-content-elm4">
                  <img
                    alt="image"
                    src={props.imageActive31}
                    className="navbar-image14"
                  />
                  <div className="navbar-thq-text-elm4">
                    <div className="navbar-container13">
                      <span className="navbar-text21">
                        {props.chapterActive31}
                      </span>
                      <div className="navbar-thq-divider-elm4"></div>
                      <span className="navbar-text22">
                        {props.indexActive31}
                      </span>
                    </div>
                    <span className="navbar-text23">{props.nameActive31}</span>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <a href="#platform" className="navbar-link14">
            <div className="navbar-thq-platform-elm">
              <div className="navbar-thq-active-elm5">
                <div className="navbar-thq-content-elm5">
                  <img
                    alt="image"
                    src={props.imageActive41}
                    className="navbar-image15"
                  />
                  <div className="navbar-thq-text-elm5">
                    <div className="navbar-container14">
                      <span className="navbar-text24">
                        {props.chapterActive41}
                      </span>
                      <div className="navbar-thq-divider-elm5"></div>
                      <span className="navbar-text25">
                        {props.indexActive41}
                      </span>
                    </div>
                    <span className="navbar-text26">{props.nameActive41}</span>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <a href="#initiative" className="navbar-link15">
            <div className="navbar-thq-initiative-elm">
              <div className="navbar-thq-active-elm6">
                <div className="navbar-thq-content-elm6">
                  <img
                    alt="image"
                    src={props.imageActive51}
                    className="navbar-image16"
                  />
                  <div className="navbar-thq-text-elm6">
                    <div className="navbar-container15">
                      <span className="navbar-text27">
                        {props.chapterActive51}
                      </span>
                      <div className="navbar-thq-divider-elm6"></div>
                      <span className="navbar-text28">
                        {props.indexActive51}
                      </span>
                    </div>
                    <span className="navbar-text29">{props.nameActive51}</span>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <a href="#consultancy" className="navbar-link16">
            <div className="navbar-thq-consultancy-elm">
              <div className="navbar-thq-active-elm7">
                <div className="navbar-thq-content-elm7">
                  <img
                    alt="image"
                    src={props.imageActive61}
                    className="navbar-image17"
                  />
                  <div className="navbar-thq-text-elm7">
                    <div className="navbar-container16">
                      <span className="navbar-text30">
                        {props.chapterActive61}
                      </span>
                      <div className="navbar-thq-divider-elm7"></div>
                      <span className="navbar-text31">
                        {props.indexActive61}
                      </span>
                    </div>
                    <span className="navbar-text32">{props.nameActive61}</span>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <a href="#education" className="navbar-link17">
            <div className="navbar-thq-education-elm">
              <div className="navbar-thq-active-elm8">
                <div className="navbar-thq-content-elm8">
                  <img
                    alt="image"
                    src={props.imageActive71}
                    className="navbar-image18"
                  />
                  <div className="navbar-thq-text-elm8">
                    <div className="navbar-container17">
                      <span className="navbar-text33">
                        {props.chapterActive71}
                      </span>
                      <div className="navbar-thq-divider-elm8"></div>
                      <span className="navbar-text34">
                        {props.indexActive71}
                      </span>
                    </div>
                    <span className="navbar-text35">{props.nameActive71}</span>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <span className="navbar-text36 formula_button">{props.text81}</span>
        </div>
        <div className="navbar-thq-bot-elm">
          <div className="navbar-container18">
            <a
              href="https://www.instagram.com/romania"
              target="_blank"
              rel="noreferrer noopener"
              className="navbar-link18"
            >
              <div className="navbar-container19">
                <img
                  alt={props.imageAlt31}
                  src={props.imageSrc31}
                  className="navbar-image19"
                />
              </div>
            </a>
            <a
              href="https://www.facebook.com/romania"
              target="_blank"
              rel="noreferrer noopener"
              className="navbar-link19"
            >
              <div className="navbar-container20">
                <img
                  alt={props.imageAlt41}
                  src={props.imageSrc41}
                  className="navbar-image20"
                />
              </div>
            </a>
            <a
              href="https://www.tiktok.com/@romania"
              target="_blank"
              rel="noreferrer noopener"
              className="navbar-link20"
            >
              <div className="navbar-container21">
                <img
                  alt={props.imageAlt51}
                  src={props.imageSrc51}
                  className="navbar-image21"
                />
              </div>
            </a>
            <a
              href="https://www.linkedin.com/company/romania/"
              target="_blank"
              rel="noreferrer noopener"
              className="navbar-link21"
            >
              <div className="navbar-container22">
                <img
                  alt={props.imageAlt521}
                  src={props.imageSrc521}
                  className="navbar-image22"
                />
              </div>
            </a>
          </div>
        </div>
        <div>
          <div className="navbar-container24">
            <Script
              html={`<script>
(function() {
  var mobileMenu = document.querySelector("#mobile-menu");
  var closeButton = document.querySelector("#close-mobile-menu");
  var closenavButton = document.querySelector("#close-sub-menu");
  var openButton = document.querySelector("#open-mobile-menu");
  if (mobileMenu && closeButton && openButton) {
    openButton.addEventListener("click", function() {
      mobileMenu.style.display = "block";
    });
    closeButton.addEventListener("click", function() {
      mobileMenu.style.display = "none";
    });
    if (closenavButton) {
      closenavButton.addEventListener("click", function() {
        mobileMenu.style.display = "none";
      });
    }
  }
})();
</script>`}
            ></Script>
          </div>
        </div>
      </div>
    </div>
  )
}

Navbar.defaultProps = {
  imageSrc31: '/frames/ig_blue1.svg',
  nameActive21: 'Media House',
  rootClassName7: '',
  chapterActive21: 'Chapter 03',
  finbestSrc1: '/logo/romania_logo.svg',
  chapterActive31: 'Chapter 04',
  indexActive8: '08',
  imageActive61: '/nav patterns/consultancy.svg',
  rootClassName1: '',
  imageActive21: '/nav patterns/media%20house.svg',
  rootClassName8: '',
  imageActive31: '/nav patterns/media%20hub.svg',
  indexActive21: '08',
  chapterActive41: 'Chapter 05',
  nameActive71: 'Education Program',
  chapterActive61: 'Chapter 07',
  imageSrc51: '/frames/tt_blue.svg',
  rootClassName6: '',
  rootClassName4: '',
  nameActive51: 'Origin & Heritage Initiative',
  indexActive71: '08',
  nameActive31: 'Media Hub',
  chapterActive51: 'Chapter 06',
  nameActive11: 'Country Brand',
  imageAlt51: 'image',
  indexActive51: '08',
  imageActive2: '/nav patterns/ambassadors.svg',
  rootClassName3: '',
  text8: 'Litepaper',
  rootClassName2: '',
  imageActive51: '/nav patterns/made%20in%20ro.svg',
  nameActive61: 'Consultancy Service',
  rootClassName: '',
  chapterActive71: 'Chapter 08',
  indexActive41: '08',
  imageSrc41: '/frames/fb_blue.svg',
  imageActive71: '/nav patterns/education.svg',
  imageAlt521: 'image',
  imageAlt31: 'image',
  imageSrc1: '/logo/romania_logo2.svg',
  nameActive41: 'The Platform',
  text82: 'Litepaper',
  rootClassName5: '',
  indexActive61: '08',
  text81: 'Litepaper',
  chapterActive2: 'Chapter 01',
  imageActive11: '/nav patterns/country%20brand.svg',
  imageAlt41: 'image',
  indexActive31: '08',
  nameActive1: 'Ambassador Program',
  imageActive41: '/nav patterns/platform.svg',
  finbestAlt1: 'pastedImage',
  imageSrc521: '/frames/in_blue.svg',
  imageAlt1: 'image',
  indexActive11: '08',
  chapterActive11: 'Chapter 02',
}

Navbar.propTypes = {
  imageSrc31: PropTypes.string,
  nameActive21: PropTypes.string,
  rootClassName7: PropTypes.string,
  chapterActive21: PropTypes.string,
  finbestSrc1: PropTypes.string,
  chapterActive31: PropTypes.string,
  indexActive8: PropTypes.string,
  imageActive61: PropTypes.string,
  rootClassName1: PropTypes.string,
  imageActive21: PropTypes.string,
  rootClassName8: PropTypes.string,
  imageActive31: PropTypes.string,
  indexActive21: PropTypes.string,
  chapterActive41: PropTypes.string,
  nameActive71: PropTypes.string,
  chapterActive61: PropTypes.string,
  imageSrc51: PropTypes.string,
  rootClassName6: PropTypes.string,
  rootClassName4: PropTypes.string,
  nameActive51: PropTypes.string,
  indexActive71: PropTypes.string,
  nameActive31: PropTypes.string,
  chapterActive51: PropTypes.string,
  nameActive11: PropTypes.string,
  imageAlt51: PropTypes.string,
  indexActive51: PropTypes.string,
  imageActive2: PropTypes.string,
  rootClassName3: PropTypes.string,
  text8: PropTypes.string,
  rootClassName2: PropTypes.string,
  imageActive51: PropTypes.string,
  nameActive61: PropTypes.string,
  rootClassName: PropTypes.string,
  chapterActive71: PropTypes.string,
  indexActive41: PropTypes.string,
  imageSrc41: PropTypes.string,
  imageActive71: PropTypes.string,
  imageAlt521: PropTypes.string,
  imageAlt31: PropTypes.string,
  imageSrc1: PropTypes.string,
  nameActive41: PropTypes.string,
  text82: PropTypes.string,
  rootClassName5: PropTypes.string,
  indexActive61: PropTypes.string,
  text81: PropTypes.string,
  chapterActive2: PropTypes.string,
  imageActive11: PropTypes.string,
  imageAlt41: PropTypes.string,
  indexActive31: PropTypes.string,
  nameActive1: PropTypes.string,
  imageActive41: PropTypes.string,
  finbestAlt1: PropTypes.string,
  imageSrc521: PropTypes.string,
  imageAlt1: PropTypes.string,
  indexActive11: PropTypes.string,
  chapterActive11: PropTypes.string,
}

export default Navbar
